import { CompanyListItem } from '../../company.model';
import {
  CompanyListGridData,
  CompanyListGridItem,
  CompanyListPersistedPagination
} from './company-list.models';

export function getPaginationPage(pagination: CompanyListPersistedPagination): number {
  if (pagination.page) {
    return pagination.page;
  }
  return Math.floor(pagination.firstRowOffset / pagination.pageSize) + 1;
}

export function getMatchingGridData(
  gridData: CompanyListGridData | null,
  pagination: CompanyListPersistedPagination,
  requestedPage: number
): CompanyListGridData | null {
  if (!gridData || getPaginationPage(pagination) !== requestedPage) {
    return null;
  }
  return gridData;
}

export function mapCompanyListItemToGridItem(
  item: CompanyListItem,
  formatLocation: (location: string) => string
): CompanyListGridItem {
  return {
    id: item.id,
    companyName: item.companyName,
    location: formatLocation(item.location),
    industryType: item.industryTypeName,
    source: item.source,
    website: item.companyWebsite || '',
    careerPageLink: item.companyCareerPage || '',
    isBlackListed: item.isBlackListed,
    flameLevel: item.flameLevel ?? 0,
    flameLevelId: item.flameLevelId ?? null
  };
}
